<template>
  <div class="to-do-list-item">
    <div @click.stop="$_checkComplete()">
      <LvTooltipButton
        ref="LvTooltipButton"
        longWidth
        icon="icon-check-circle-outline"
        active-icon="icon-check-circle-filled"
        :active="complete"
        :notAllow="!priority"
        :tooltipText="_tooltipText"
        :activeTooltipText="_activeTooltipText"
      />
    </div>
    <div class="item-content">
      <div class="title-wrap">
        <p class="title" :class="{ complete: complete }" @click.stop="$_subTaskPopupOpen()">
          {{ name }}
        </p>
        <WsTextChip001
          gray
          icon-lg
          font-size-sm
          leading-icon="icon-duedate"
          :text-label="$_dateFormat(expiredDate)"
          :red="$_getDateExpired(expiredDate)"
        />
      </div>
      <div class="content-list">
        <div class="list-item">
          <p class="text">
            {{ $t('任務') }}
          </p>
          <WsTextButton001 primary no-padding font-size-xs @click="$_popUpOpen()">
            {{ taskName }}
          </WsTextButton001>
        </div>
        <div class="list-item">
          <p class="text">
            {{ $t('指派者') }}
          </p>
          <p class="text blue">
            {{ creator.name }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import H_time from '@/helpers/time';

export default {
  name: 'ToDoListItem',
  props: {
    complete: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    taskName: {
      type: String,
      default: '',
    },
    creator: {
      type: Object,
      default() {
        return {};
      },
    },
    taker: {
      type: Object,
      default() {
        return {};
      },
    },
    expiredDate: {
      type: String,
      default: '',
    },
    subTaskId: {
      type: [Number, String],
      default: 0,
    },
    taskId: {
      type: [Number, String],
      default: 0,
    },
    priority: {
      type: Boolean,
      default: false,
    },
    reply: {
      type: String,
    },
  },
  data: () => ({
    popUpActive: false,
    subTaskPopupActive: false,
    alertPopupActive: false,
    taskField: [
      {
        name: '建築消防安全管理',
        leadingIcon: 'icon-firefighting',
      },
      {
        name: '水污染防治',
        leadingIcon: 'icon-water',
      },
    ],
    taskDate: new Date(),
    founder: {
      name: '張宜玲',
      avatar: require('@/assets/image/jo.jpeg'),
      time: '2020.01.03',
    },
    taskLeader: {
      name: '李大民',
      avatar: require('@/assets/image/jo.jpeg'),
    },
    taskComplete: false,
    taskContent: null,
    subTaskContent: {
      id: 0,
      name: '',
      taskName: '',
      remark: '',
      taker: null,
      taskTaker: null,
      expiredDate: '',
      attaches: [],
      reply: '',
      replyAttaches: [],
      replyImages: [],
    },
  }),
  computed: {
    _replyDisable() {
      if (this.taskComplete && !this.subTaskContent.reply) {
        return true;
      } else {
        return false;
      }
    },
    _currentFactoryId() {
      return this.$store.state.app.factoryId;
    },
    _taskContent() {
      if (!this.taskContent)
        return {
          id: '',
          name: '',
          systemSubclasses: [],
          remark: '',
          expiredDate: '',
          taker: null,
          creator: null,
          subTasks: [],
          updateDate: '',
          updater: null,
          event: null,
          alert: null,
        };
      let taskContent = {
        id: this.taskContent.id,
        name: this.taskContent.name,
        systemSubclasses: this.taskContent.system_subclasses,
        remark: this.taskContent.remark,
        expiredDate: this.$_dateFormat(this.taskContent.expired_at),
        taker: this.taskContent.taker,
        creator: this.taskContent.creator,
        subTasks: this.taskContent.sub_tasks,
        updateDate: this.$_dateFormat(this.taskContent.updated_at),
        event: this.taskContent.event,
        alert: this.taskContent.alert,
      };
      return taskContent;
    },
    _subTaskCompleteNumber() {
      if (this._taskContent.subTasks.length === 0) return 0;
      const completeSubTasks = this._taskContent.subTasks.filter(subTask => subTask.done_at);
      return completeSubTasks.length;
    },
    _eventCardList() {
      let eventCardList = [];
      if (!this.taskContent) return eventCardList;
      if (this.taskContent.article) {
        eventCardList.push({
          id: this.taskContent.article.id,
          type: 'article',
        });
      } else if (this.taskContent.event) {
        eventCardList.push({
          id: this.taskContent.event.id,
          type: 'event',
        });
      } else if (this.taskContent.alert) {
        eventCardList.push({
          id: this.taskContent.alert.id,
          type: 'alert',
        });
      }
      return eventCardList;
    },
    _tooltipText() {
      if (!this.priority) return '你無權限標記他人的待辦事項';
      return this.reply ? '標記為完成' : '尚未填寫執行結果';
    },
    _activeTooltipText() {
      return this.priority ? '標記為未完成' : '你無權限標記他人的待辦事項';
    },
  },
  watch: {
    complete() {
      this.taskComplete = this.complete;
    },
  },
  mounted() {
    this.taskComplete = this.complete;
  },
  methods: {
    $_subTaskPopupOpen() {
      if (!this.priority) return;
      this.$emit('subtask-popup-open');
    },
    $_subTaskPopupClose() {
      this.$emit('subtask-popup-close');
    },
    $_checkComplete() {
      if (!this.priority) return;
      if (!this.reply) this.$emit('subtask-popup-open');
      else {
        this.$emit('click');
        this.taskComplete = !this.taskComplete;
      }
    },
    $_popUpClose() {
      this.$emit('task-popup-close');
    },
    $_popUpOpen() {
      this.$emit('task-popup-open');
    },
    $_dateFormat(date) {
      if (!date) return;
      return this.$moment(date).format('YYYY-MM-DD');
    },
    $_getDateExpired(date) {
      return H_time.isExpired(date);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/component/to-do-list-item';
</style>
